import {getData, LOGIN} from "../../storage";
import {isEmpty} from "../../utility";
import assets from "../../assets";
import strings from "../../strings";
import api from "../broadcaster/library";

const unFollowAPI = (props,data, broadcaster_id ) => {

    const payload = {
        image: assets.broadcast.cross,
        title: strings.clipstore.broadcaster.unfollow.title,
        description: strings.clipstore.broadcaster.unfollow.description
    };
    const isConfirmationModal = true;
    const actionArray = [{
        text: "NO",
        click: () => {
            console.log("Clicked on CANCEL");
            props.hideCommonModal()
        }
    }, {
        text: "YES",
        click: () => {
            console.log("Clicked on OK")
            props.unFollowBroadcaster(
                data.token,
                data.api_token,
                broadcaster_id
            );
        }
    }];

    props.showCommonModal(payload, isConfirmationModal, actionArray);
}


export default {
    unFollowAPI
}